module.exports = __webpack_public_path__ + "img/rtl2_calogero.0dacbe8f.jpg";